import React from "react";
import styled, { css } from "styled-components";
import Thickness from "./Components/Thickness";
import Variations from "./Components/Variations";
import Button from "../../../Button";
import Modal from "../../../Modal";
import ListItem from "../ListItem";
import { rem } from "polished";
import { useDispatch, useSelector } from "react-redux";
import {
  changeTexture,
  changeTileShape,
  getDimensions,
  getSelectedTile,
} from "../../../../lib/redux/slices/dimensions-slice";
import TileInputField from "./Components/TileInputField";

import Texture from "./Components/Texture";
import TileTypeSelect from "./Components/TileTypeSelect";

const Selected = ({ data, stage, canvasOffsetX }) => {
  const selectedTile = useSelector(getSelectedTile);

  if (!data && !Object.entries(selectedTile).length) return null;
  const { bankskiva } = data;

  const hasVertical = selectedTile?.settings?.configuration.vertical || false;
  const variationImage = selectedTile?.variations[0].center_image || "";

  return (
    <Layout>
       <Texture /> 
        
      <TileTypeSelect
        data={bankskiva}
        stage={stage}
        canvasOffsetX={canvasOffsetX}
      />
      {selectedTile?.settings?.thickness_with_price && (
        <Thickness data={selectedTile?.settings?.thickness_with_price} />
      )}

     <TileInputField
        variationImage={variationImage}
        hasVertical={hasVertical}
      />

      

       {selectedTile?.variations && (
        <Variations data={selectedTile?.variations} />
      )}
     
    </Layout>
  );
};
export default Selected;

const Layout = styled.div`
  ${({ theme }) => css`
    .builder-element {
      + .builder-element {
        border-top: 1px solid ${theme.colors.gray["600"]};
        margin-top: ${rem(20)};
        padding-top: ${rem(20)};
      }
    }
  `}
`;
